import React from "react";
import createSvgIcon from "../utils/createSvgIcon";
export default createSvgIcon(React.createElement(React.Fragment, null, React.createElement("path", {
  d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
  fill: "#339642"
}), React.createElement("path", {
  d: "M18.5808 8.29041L9.7509 17.112L5.43555 12.697",
  stroke: "white",
  strokeWidth: "1.5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
})), "IconMessageSuccess");